var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "10.9521848%",
    x2: "92.2525491%",
    y2: "89.0478152%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staker---staking-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-6",
    transform: "translate(-36.000000, -47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cosmos-logo-horizontal-dark",
    transform: "translate(37.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9999365,0 C58.9867462,0 76,17.0131586 76,37.9999365 C76,58.9867462 58.9867462,76 37.9999365,76 C17.0131586,76 0,58.9867462 0,37.9999365 C0,17.0131586 17.0131586,0 37.9999365,0 Z",
    id: "Path",
    strokeOpacity: 0.2,
    stroke: "#00F3AB",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6793584,19.2212323 C47.1894809,18.9262559 47.8105227,18.9262559 48.3206453,19.2212323 L58.1683664,25.1261422 C58.6868585,25.4209832 59.0065478,25.9880583 59.0000519,26.6012349 L59.0000519,38.4019772 C58.9971731,39.0125374 58.6800611,39.5750409 58.1683664,39.8770699 L48.3206453,45.7774411 C48.0675577,45.927208 47.7804273,46.0039979 47.4890599,46 C47.2018617,45.99746 46.9211647,45.9109211 46.6793584,45.7502086 L36.8316373,39.8498374 C36.4231241,39.6035398 36.1560405,39.2017151 36.0595637,38.7586683 L27.5110712,33.6322864 L19.3046564,38.578325 L19.3046564,48.4113586 L27.5110712,53.3392299 L35.717486,48.4113586 L35.717486,45.6408503 C35.717486,44.7002092 36.4523134,43.9376689 37.358769,43.9376689 C38.2652245,43.9376689 39.0000519,44.7002092 39.0000519,45.6408503 L39.0000519,49.3878492 C38.9972733,49.9988224 38.680162,50.5617064 38.1684685,50.8639397 L28.3207708,56.7683016 C28.0685453,56.9213431 27.7813621,57.0013363 27.4891874,57 C27.2071399,57.0024586 26.9289065,56.9322278 26.6794878,56.7955525 L16.8317901,50.8911906 C16.3119004,50.5953813 15.9919841,50.025771 16.0000519,49.4105583 L16.0000519,37.6018344 C16.0029853,36.9908612 16.3200966,36.4279772 16.8317901,36.1257439 L26.6794878,30.2213819 C27.1896091,29.926206 27.8106495,29.926206 28.3207708,30.2213819 L38.1684685,36.1075766 C38.5659405,36.3473801 38.8424428,36.7462647 38.940876,37.20088 L47.4890599,42.3234546 L55.6954942,37.3989141 L55.6954942,27.5725268 L47.4890599,22.6298313 L39.2826256,27.5725268 L39.2826256,30.1596126 C39.2754832,31.0965327 38.5448214,31.8542359 37.6413388,31.8616427 C36.7378561,31.8542359 36.0071944,31.0965327 36.0000519,30.1596126 L36.0000519,26.5966962 C36.0028306,25.986136 36.3199426,25.4236324 36.8316373,25.1216034 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    transform: "translate(37.500026, 38.000031) scale(-1, 1) translate(-37.500026, -38.000031) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/matic.964c0613d9b39f58880bea077aa276a6.svg";
export { ForwardRef as ReactComponent };